
import { useAuth } from "@/contexts/AuthContext";
import { LoginForm } from "@/components/auth/LoginForm";
import { UserDropdownMenu } from "@/components/auth/UserDropdownMenu";
import { SignUpForm } from "./SignUpForm";

export function NavbarUserProfile() {
  const { isAuthenticated, isAdmin, username, userCredits, logout } = useAuth();

  return (
    <>
      {isAuthenticated ? (
        <UserDropdownMenu 
          username={username}
          isAdmin={isAdmin}
          userCredits={userCredits}
          onLogout={logout}
        />
      ) : (
        <div className="flex gap-2">
          <LoginForm />
        </div>
      )}
    </>
  );
}
